module.exports = __webpack_public_path__ + "static/cicada_img2-e1433f6187c05c7c1e48495e0e1f3143.png";